import { getRandomEnumValue } from '../../utils/dummy-data';
import { PlanType } from '../model/enum/plan-type';
import { SubscriptionPlan } from '../model/subscription-plan';
import { USER_PROFILES } from './user-profiles';

export const PLANS = USER_PROFILES.reduce(
  (acc: SubscriptionPlan[], profile) => {
    acc.push({
      id: profile.user.id!,
      profile,
      subscriptionPlan: getRandomEnumValue(PlanType),
    });
    return acc;
  },
  []
);
